import { useEffect } from "react";
import { useBootstrap } from "../contexts/BootstrapContext";
import FeatureSessionStore from "../uidispatcherapi/FeatureSessionStore";

export default function BootstrapCSS({ usesBootstrap }: { usesBootstrap?: boolean }) {
	const { enableBootstrap, disableBootstrap } = useBootstrap();

	useEffect(() => {
		if (usesBootstrap && FeatureSessionStore.getMembershipFor("OC_BOOTSTRAP_CSS_OFF") !== "B") {
			enableBootstrap();
		}

		if (!usesBootstrap) {
			disableBootstrap();
		}
	}, [usesBootstrap, enableBootstrap, disableBootstrap]);

	return null;
}
